import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const useNotificationAction = () => {
  const navigate = useNavigate();
  const [imageModal, setImageModal] = useState(false);
  const [data, setData] = useState(null);

  const handleNotificationStatus = async (item, onClose) => {
    try {
      let itemPayload;
      if (typeof item?.payload === "string") {
        itemPayload = JSON.parse(item?.payload);
      } else {
        itemPayload = item?.payload;
      }

      const isUnread = item.is_read === 0;
      const knownType = ["1", "3", "4", "6", "7", "9"].includes(String(item.type));

      if (isUnread && knownType) {
        await axios.put(
          process.env.REACT_APP_API_URL + `/notifications/mark-as-read`,
          { groupTag: item.group_tag },
          { withCredentials: true }
        );
      }

      if (String(item?.type) === "7") {
        if (onClose) onClose();
        navigate("/delivery-for-you/orders");
      } else if (String(item?.type) === "9") {
        if (onClose) onClose();
        navigate("/orders");
      } else if (itemPayload !== null && itemPayload?.image !== null) {
        setImageModal(true);
        setData({ image: itemPayload?.image, link: item?.action });
      } else if (item.action !== null) {
        const link = document.createElement("a");
        link.target = "_blank";
        link.href = item.action;
        link.rel = "noopener noreferrer";
        link.click();
      } else {
        if (onClose) onClose();
        navigate("/notifications");
      }
    } catch (err) {
      const tempErr = err?.response?.data?.error;
      if (tempErr?.status === 404 && tempErr?.message === "No Record Found") {
        return [];
      }
    }
  };

  const closeImageModal = () => {
    setImageModal(false);
    setData(null);
  };

  return { handleNotificationStatus, imageModal, data, closeImageModal };
};

export default useNotificationAction;
